import React, { useCallback, useState } from "react";
import { Shield, X } from "lucide-react";
import CheckConnectivityUsernameField from "./CheckConnectivityUsernameField";
import CheckConnectivityPasswordField from "./CheckConnectivityPasswordField";
import { authenticateUserLDAP } from "../authService";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function AuthCheckConnectivityPopup({ closePopup, ip, baseDN, serviceName, servicePassword, confirm }) {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    const onTestClick = async () => {
        const authenticateData = {
            ip: ip,
            baseDN: baseDN,
            serviceName: serviceName,
            servicePassword: servicePassword,
            username: username,
            password: password
        }
        const response = await authenticateUserLDAP(authenticateData);
        confirm(response);
        closePopup();
    };

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-auth-server-check-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--compact" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <Shield size={18} />
                        </div>
                        <div>
                            <h4 id="oct-auth-server-check-title" className="oct-shared-popup__title">Test Authentication Server</h4>
                            <p className="oct-shared-popup__subtitle">Verify connectivity using a username and password against the configured server.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close authentication server test popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--form">
                    <CheckConnectivityUsernameField value={username} onChange={(value) => setUsername(value)} />
                    <CheckConnectivityPasswordField value={password} onChange={(value) => setPassword(value)} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn oct-shared-popup__btn oct-shared-popup__btn--primary"
                        disabled={!password || !username}
                        onClick={onTestClick}
                    >
                        Test
                    </button>
                </div>
            </div>
        </div>
    )

}

export default AuthCheckConnectivityPopup;
